var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.$t('errorPage.notFoundTitle'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }